import { render, staticRenderFns } from "./DeleteSectionModal.vue?vue&type=template&id=bd85d1be&scoped=true&"
import script from "./DeleteSectionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd85d1be",
  null
  
)

export default component.exports